import { SiteType } from '@on3/api/src';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { useSite } from '@on3/ui-lib/index';
import { useModal } from '@public/components/Modals';
import { useEffect } from 'react';

export enum ArticleOffer {
  NON_SUBSCRIBER_ANNUAL = 'non_subscriber_annual',
}

export const ArticleOffers = () => {
  const { currentSite } = useSite();
  const { isSubscribed } = useSubscribe();
  const { showModal } = useModal();

  // ArticleOffer.NON_SUBSCRIBER_ANNUAL
  // Show annual non-subscriber offer after scrolling 500px if not shown in the last hour and on Team or Channel sites
  useEffect(() => {
    if (
      isSubscribed ||
      ![SiteType.Team, SiteType.Channel].includes(currentSite.type)
    )
      return;

    const now = Date.now();
    const lastShown = localStorage.getItem(ArticleOffer.NON_SUBSCRIBER_ANNUAL);
    const oneHour = 60 * 60 * 1000;

    const handleScroll = () => {
      if (
        window.scrollY > 500 &&
        (!lastShown || now - parseInt(lastShown) > oneHour)
      ) {
        showModal('offers.article.non_subscriber_annual');

        localStorage.setItem(
          ArticleOffer.NON_SUBSCRIBER_ANNUAL,
          now.toString(),
        );

        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentSite, isSubscribed, showModal]);

  return null;
};
